
































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { NewsModule } from '@/store/modules/news/news.store';

import TextEditor from '@/plugins/text-editor/TextEditor.vue';
import NewsArticle from '@/components/frontpage/news/NewsArticle.vue';
import { ApiPermissions } from '@/core/security/Permissions';
import { NewsViewObject, NewsEditRequest, NewsDeleteRequest } from '@/types/apiServerContract';

@Component({
    components: {
        TextEditor,
        NewsArticle
    }
})
export default class EditNews extends Vue {
	permissions: string[] = [ApiPermissions.News.EditNews];
	news: NewsViewObject | null = null;
	originalNews: NewsViewObject | null = null;
	currentIndex: number = 0;

	loading: boolean = false;

	get News(): NewsViewObject[] {
	    return NewsModule.news;
	}

	@Watch('News')
	onNewsChange(n: NewsViewObject[], o: NewsViewObject[]) {
	    this.SetNewsToDefault();
	}

	Next() {
	    if (this.currentIndex >= this.News.length - 1) return;

	    const news = this.News[++this.currentIndex];
	    this.news = {
	        id: news.id,
	        title: news.title,
	        content: news.content,
	        date: news.date,
	        author: news.author,
	        authorName: news.authorName,
	        authorEmail: news.authorEmail,
	        emailHidden: news.emailHidden,
	        commentCount: news.comments.length,
	        comments: news.comments,
	        reactions: []
	    };
	    this.originalNews = Object.assign({}, this.news);
	}

	Prev() {
	    if (this.currentIndex <= 0) return;

	    const news = this.News[--this.currentIndex];
	    this.news = {
	        id: news.id,
	        title: news.title,
	        content: news.content,
	        date: news.date,
	        author: news.author,
	        authorName: news.authorName,
	        authorEmail: news.authorEmail,
	        emailHidden: news.emailHidden,
	        commentCount: news.comments.length,
	        comments: news.comments,
	        reactions: []
	    };
	    this.originalNews = Object.assign({}, this.news);
	}

	async EditNews() {
	    if (!this.news) return;

	    const check = await this.$bvModal.msgBoxConfirm('Are you sure this news is ready for submitting?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    const request: NewsEditRequest = {
	        newsId: this.news.id,
	        title: this.news.title,
	        content: this.news.content
	    };

	    try {
	        this.loading = true;
	        await NewsModule.EditNews(request);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('News edited successfully', {
	        variant: 'success',
	        title: 'Success'
	    });
	}

	async Delete() {
	    if (!this.news) return;

	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this news article?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    const request: NewsDeleteRequest = {
	        newsId: this.news.id
	    };

	    try {
	        this.loading = true;
	        await NewsModule.DeleteNews(request);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('News deleted successfully', {
	        variant: 'success',
	        title: 'Success'
	    });

	    this.SetNewsToDefault();
	}

	Reset() {
	    this.news = Object.assign(this.news, this.originalNews);
	    this.$nextTick(() => {
	        (this.$refs.EditNews as any).reset();
	    });
	}

	SetNewsToDefault() {
	    const news = this.News[0];
	    if (!news) {
	        this.news = null;
	        this.originalNews = null;
	        return;
	    }

	    this.news = {
	        id: news.id,
	        title: news.title,
	        content: news.content,
	        date: news.date,
	        author: news.author,
	        authorName: news.authorName,
	        authorEmail: news.authorEmail,
	        emailHidden: news.emailHidden,
	        commentCount: news.commentCount,
	        comments: news.comments,
	        reactions: news.reactions
	    };

	    this.originalNews = Object.assign({}, this.news);
	}

	created() {
	    this.SetNewsToDefault();
	}
}
